import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { Company, PaymentsSettings, QueryCompanyArgs } from "@oysterhr/schema"

const QUERY = gql`
  query PayrollContextGetCompanyDetails($companyId: ID!) {
    company(companyId: $companyId) {
      id
      isClient
      isCustomer
      paymentsSettings {
        restricted
        authorizations {
          actions
        }
      }
      authorizations {
        actions
      }
    }
  }
`

type QueryArgs = QueryCompanyArgs
export type PayrollContextCompany = Pick<
  Company,
  "id" | "isClient" | "isCustomer" | "authorizations"
> & {
  paymentsSettings: Pick<PaymentsSettings, "restricted" | "authorizations">
}

export const useGetCompanyDetails = ({ companyId }: QueryArgs) =>
  useQuery<{ company: PayrollContextCompany }, QueryArgs>(QUERY, {
    fetchPolicy: "cache-first",
    variables: { companyId },
  })
